// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon-v8v3F","root":"root-12ySP","type_account":"type_account-34Wr8","type_review":"type_review-3jkRu","security_code":"security_code-2wKOp"};